import { jsx, Fragment } from "@emotion/react/jsx-runtime";
import i18n from "i18next";
import ICU from "i18next-icu";
import { useState, useEffect } from "react";
import { initReactI18next } from "react-i18next";
import resources from "./resources.generated.js";
const DEFAULT_LANGUAGE = "en-US";
function findFallbackLng(code) {
  switch (code) {
    case "pt":
      return "pt-BR";
    case "de":
      return "de-DE";
    case "es":
      return "es-ES";
    case "en":
      return "en-US";
    default:
      return DEFAULT_LANGUAGE;
  }
}
const I18nProvider = ({
  children,
  language
}) => {
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    const lng = language != null ? language : DEFAULT_LANGUAGE;
    i18n.use(ICU).use(initReactI18next).init({
      fallbackLng: findFallbackLng,
      interpolation: {
        escapeValue: false
      },
      lng,
      resources,
      returnNull: false
    }).then(() => {
      setIsInitialized(true);
    });
  }, [language]);
  return isInitialized ? /* @__PURE__ */ jsx(Fragment, { children }) : null;
};
export {
  DEFAULT_LANGUAGE,
  I18nProvider,
  findFallbackLng
};
